import { render } from "./DeliveryOrders.html?vue&type=template&id=2fed0be9&scoped=true"
import script from "./DeliveryOrders.js?vue&type=script&lang=js"
export * from "./DeliveryOrders.js?vue&type=script&lang=js"

import "./DeliveryOrders.css?vue&type=style&index=0&id=2fed0be9&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fed0be9"]])

export default __exports__